import Service from "../../AuthService";

const Driver = {
    getDriver(page) {
        return Service.get("/driver?page="+page);
    },
    getDriverAll(){
        return Service.get("/driver_get_all");
    },
    showDriver(id) {
        return Service.get("/driver/" + id);
    },
    updateDriver(id, data) {
        return Service.put("/driver/" + id, data);
    },
    createDriver(data) {
        return Service.post("/driver", data);
    },
    deleteDriver(id,data) {
        return Service.post("/delete_driver/" +id,data);
    },
    searchDriver(page,data) {
        return Service.post("/driver-search?page="+page,data);
    },
    getDriverFromInvoice(transport_type_id){
        return Service.get("/driver_from_invoice?transport_type_id="+transport_type_id);
    },
    getDriverBigCar(page,driver_name){
        return Service.get('/get_driver_big_car?page='+page+'&driver_name='+driver_name);
    },
    getDriverById(id){
        return Service.get('/get_driver_by_id/'+id)
    },
    /*create 25/11/2020*/
    updateSettingTaxAuto(data){
        return Service.post('/update_setting_tax_auto',data);
    },
    showSettingTaxAuto(){
        return Service.get('/get_setting_tax_auto');
    },
    onePercent(data){
        return Service.get(`/one_percent?date_start=${data.date_start}&date_end=${data.date_end}`);
    },
    transportSale(data){
        return Service.get(`/transport_sale?date_start=${data.date_start}&date_end=${data.date_end}`);
    },
    getRemaining(id){
        return Service.get(`/get_remaining?id=${id}`);
    },
};
export default Driver;
